// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import { siteActions } from "../../redux/actions/siteActions";
import Home                   from './Home';

const mapStateToProps = state => {
  return {
    loading: state.siteReducer.loading,
    error: state.siteReducer.error,
    siteList:  state.siteReducer.siteList,
    dashboardData: state.siteReducer.dashboardData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...siteActions
      },
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/app/views/home/index.js